// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1-FM7","legacyBtn":"MutateMid_legacyBtn__2SCMU"};